import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=c4525edc&scoped=true"
import script from "./Member.vue?vue&type=script&lang=ts"
export * from "./Member.vue?vue&type=script&lang=ts"
import style0 from "./Member.vue?vue&type=style&index=0&id=c4525edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4525edc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectMember: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/project-member.vue').default})
